import { render, staticRenderFns } from "./CashPosto.vue?vue&type=template&id=564d051c"
import script from "./CashPosto.vue?vue&type=script&lang=js"
export * from "./CashPosto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports